export default [
  { label: 'Lato', value: 'Lato' },
  { label: 'Arial', value: 'Arial' },
  { label: 'Open Sans', value: 'Open Sans' },
  { label: 'Raleway', value: 'Raleway' },
  { label: 'Roboto', value: 'Roboto' },
  { label: 'Times New Roman', value: 'Times New Roman' },
];
